import { useEffect } from "react";
import { useDragLayer } from "react-dnd";
import styles from "./styles.module.css";

export default function DragLayer() {
  const { isDragging, item, cursor } = useDragLayer((monitor) => ({
    item: monitor.getItem(),
    cursor: monitor.getClientOffset(),
    isDragging: monitor.isDragging(),
  }));

  if (
    !isDragging ||
    !cursor ||
    item.type === "action" ||
    item.type === "utility" ||
    item.type === "pagecard"
  ) {
    return null;
  } else {
    return (
      <div
        style={{ left: cursor.x + 10, top: cursor.y + 10 }}
        className={styles.dragLayer}
      >
        {item.block.name}
      </div>
    );
  }
}
